import { render, staticRenderFns } from "./XInputCustomFormFields.vue?vue&type=template&id=4f9f7ad2&scoped=true"
import script from "./XInputCustomFormFields.vue?vue&type=script&lang=js"
export * from "./XInputCustomFormFields.vue?vue&type=script&lang=js"
import style0 from "./XInputCustomFormFields.vue?vue&type=style&index=0&id=4f9f7ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9f7ad2",
  null
  
)

export default component.exports